module.exports = __webpack_public_path__ + "static/img/googleplay.1e01f8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/googleplay.png
// module id = SKol
// module chunks = 0